import {Directive, ElementRef, HostListener} from '@angular/core';
import { NgControl } from '@angular/forms';
import { CsDatePickerComponent } from '../controls/cs-date-picker/cs-date-picker.component';
import * as moment from "moment";
import {NzMessageService} from "ng-zorro-antd/message";

@Directive({
  selector: 'vss-ui-date-picker[dateFormat]',
  providers: []
})
export class DateFormatDirective{

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private viewCsDate: CsDatePickerComponent,
    // private notificationService: NzNotificationService,
    private message: NzMessageService
  ) {
    control.control?.valueChanges.subscribe(
      value => {
        if(this.viewCsDate.csIsValidateRange) {
          this.viewCsDate.csIsError = value?.length == 2 && value[0].getTime() > value[1].getTime()
          if(this.viewCsDate.csIsError) {
            // this.message.error('Thời gian từ phải nhỏ hơn thời gian đến');
          }
        }
      }
    )
  }

  @HostListener('change', ['$event']) onChange(event: any) {
    const inputTarget = event.target
    if(inputTarget.value?.length != this.viewCsDate?.csFormat?.length) {
      inputTarget.value = ''
    } else {
      // this.onEvent(event)
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: any) {
    setTimeout(() => this.onEvent(event), 10)
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: any) {
    if(/\d/.test(event.key)) {
      this.onEvent(event)
    }else if (!event.target?.value) {
      if (!this.viewCsDate.csRangePicker) {
        this.control.reset()
      }
    }
  }

  onEvent(event: any) {
    const inputTarget = event.target
    let isnum = /^\d+$/.test(inputTarget.value);
    if (inputTarget.value.length === 12 && isnum && this.viewCsDate?.csFormat === 'dd/MM/yyyy HH:mm') {
      const date = inputTarget.value
      // const fullDate = `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(4, 8)} ${date.slice(8, 10)}:${date.slice(10, 12)}:${date.slice(12, 14)}`; //dd/mm/yy hh...
      const fullDate = `${date.slice(2, 4)}/${date.slice(0, 2)}/${date.slice(4, 8)} ${date.slice(8, 10)}:${date.slice(10, 12)}`;  // mm/dd/yyy hh...
      const value = new Date(fullDate)
      if (value.toString() != 'Invalid Date'  && this.checkDateHHmm(fullDate, value) && !this.checkInvalidDate(fullDate, value, 'MM/DD/YYYY HH:mm')) {
        this.setValue(value, inputTarget)
      } else {
        inputTarget.value = ''
        // this.setValue(new Date(), inputTarget)
      }
    }else if(inputTarget.value.length === 8 && isnum && this.viewCsDate?.csFormat === 'dd/MM/yyyy'){
      const date = inputTarget.value
      const controlValue = date.slice(4, 8) + "/" + date.slice(2, 4) + "/" + date.slice(0, 2);
      const value = new Date(controlValue)
      if (value.toString() != 'Invalid Date' && !this.checkInvalidDate(controlValue, value, 'YYYY/MM/DD')) {
        this.setValue(value, inputTarget)
      } else {
        inputTarget.value = ''
      }
    } else {
      const date = inputTarget.value.split("/");
      if (date.length === 3 && date[0].length === 2 && date[1].length === 2 && date[2].length === 4 && this.viewCsDate?.csFormat === 'dd/MM/yyyy') {
        const value = new Date(date[2] + '/' + date[1] + '/' + date[0]);
        if (value.toString() != 'Invalid Date' && !this.checkInvalidDate(date[2] + '/' + date[1] + '/' + date[0], value, 'YYYY/MM/DD')) {
          this.setValue(value, inputTarget)
        } else {
          inputTarget.value = ''
          // this.setValue(new Date(), inputTarget)
        }
      } else if (date.length === 3 && date[2].length === 10 && date[0].length === 2 && date[1].length === 2 && this.viewCsDate?.csFormat === 'dd/MM/yyyy HH:mm') {
        const dateTime = date[2].split(' ');
        const value = new Date(dateTime[0] + '/' + date[1] + '/' + date[0] + ' ' + dateTime[1]);
        if (value.toString() != 'Invalid Date'
          && !this.checkInvalidDate(dateTime[0] + '/' + date[1] + '/' + date[0] + ' ' + dateTime[1], value, 'YYYY/MM/DD HH:mm')
          && this.checkDateHHmm(date[1] + '/' + date[0] + '/' + dateTime[0] + ' ' + dateTime[1],value)) {
          this.setValue(value, inputTarget)
        } else {
          inputTarget.value = ''
          // this.setValue(new Date(), inputTarget)
        }
      } else if(inputTarget.value?.length > this.viewCsDate?.csFormat?.length) {
        inputTarget.value = ''
        setTimeout(() => {
          inputTarget.dispatchEvent(event)
        }, 100)
      }
    }
  }

  setValue(value: Date | null, inputTarget: HTMLInputElement) {
    setTimeout(() => {
     inputTarget.dispatchEvent(new KeyboardEvent('keyup', {key: 'Enter'}))
   }, 10)
    const formatMoment = this.viewCsDate?.csFormat.replace(/[dy]/gi, (x) => x.toUpperCase())
    inputTarget.value = value ? moment(value).format(formatMoment) : ''
    if (!this.viewCsDate.csRangePicker && value) {
      this.control.control?.setValue(!this.viewCsDate?.csDisabledDate || !this.viewCsDate.csDisabledDate(value) ? value : null, {emitEvent: false})
      this.viewCsDate.csChange.emit(this.control.control?.value)
    } else {
      const values: (Date|null)[] = []
      this.el.nativeElement.querySelectorAll('input').forEach(
        (input: HTMLInputElement) => {
          if(input.value) {
            const v = moment(input.value, formatMoment).toDate()
            values.push(v)
          } else {
            values.push(null)
          }
        }
      )
      if(values?.filter(v => !!v && v.toString() != 'Invalid Date').length == 2) {
        if(this.viewCsDate.csIsValidateRange && values[0] && values[1] ) {
          this.viewCsDate.csIsError = values[0].getTime() > values[1].getTime()
          if(this.viewCsDate.csIsError) {
            this.message.error('Thời gian từ phải nhỏ hơn hoặc bằng thời gian đến');
            this.control.control?.setValue(values, {onlySelf: false,
              emitEvent: false,
              emitViewToModelChange: false});
          }
        } else {
          this.viewCsDate.csIsError = true
        }
        if(!this.viewCsDate.csIsValidateRange || !this.viewCsDate.csIsError) {
          this.control.control?.setValue(values, {emitEvent: false})
          this.viewCsDate.csChange.emit(this.control.control?.value)
        }
      }
      // this.viewCsDate.dateRangerPickerComponent.datePicker.updateInputValue()
    }
  }
  checkInvalidDate(dateCompare: string, value: Date, format:string) {
    return moment(value).format(format) != dateCompare
  }

    checkDateHHmm(dateCompare: string, value: Date) {
    const date = dateCompare.split("/");
    const dateTime = date[2].split(' ');
    if (+dateTime[0] > 9999 || +dateTime[0] < 1000) {
      return false;
    }
    return !(value.getDate() != +date[1] || (value.getMonth() + 1) != +date[0] || value.getFullYear() != +dateTime[0]);

  }
}
